import { Box } from '@material-ui/core';
import { useState } from 'react';
import { useQuery } from 'react-query';
import { useLocation } from 'react-router-dom';
import { quickStartOnboarding } from '../../api/common';
import { getBusinessOwner } from '../../api/settings';
import AppLogout from '../../hooks/AppLogout';
import { BillingProvider } from '../../hooks/useBilling';
import SideNav from '../SideNav';
import TopNav from '../TopNav';
import TopNavBilling from '../TopNav/TopNavBilling';
import MainDrawer from './MainDrawer';
import { Body, useStyles } from './styled.layout';

/**
 * do not remove this comment please
 * useMediaQuery, from material-ui
 * useTheme from material-ui
 * const breakpointTheme = useTheme();
 *  const isMatch = useMediaQuery(breakpointTheme.breakpoints.up('xl'));
 *  : isMatch
 *  ? '0px 23em'
 *  : open
 *  ? '0px 2em'
 */

function Layout({ children }) {
  const classes = useStyles();
  const [width, setWidth] = useState(false);
  const [open, setOpen] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const { data: isBusinessData, isSuccess: isBussinessSuccess } = useQuery(
    ['current_user'],
    getBusinessOwner
  );
  const { data } = useQuery(['quick-start'], quickStartOnboarding, {
    enabled: isBussinessSuccess && isBusinessData.is_owner
  });

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const toggleWidth = () => {
    setWidth(!width);
  };

  const routesWithoutSideNav = [
    '/',
    '/login',
    '/signup',
    '/business-registration',
    '/add-business',
    '/forgot-password',
    '/forgot-password-confirm'
  ];

  const { pathname } = useLocation();
  const hideSideNav = routesWithoutSideNav.includes(pathname).toString();
  return (
    <AppLogout>
      <Box style={{ display: 'flex', background: 'white' }}>
        <SideNav hide={false} width={width} toggleWidth={toggleWidth} />
        <Body hidesidenav={false} fullWidth={width}>
          {pathname !== '/business-registration' &&
            pathname !== '/business-setup' &&
            (isBussinessSuccess &&
            isBusinessData.business.billing.eligible_to_buy_now ? (
              <TopNavBilling />
            ) : (
              <BillingProvider>
                <>
                  <TopNav hide={false} toggleWidth={toggleWidth} />
                </>
              </BillingProvider>
            ))}

          <Box
            style={{
              position: 'relative',
              background: pathname.includes('onboarding') ? '#FAFAFA' : '',
              height: '100vh',
              marginTop:
                pathname === '/dashboard'
                  ? '0em'
                  : pathname === '/business-registration'
                  ? '0em'
                  : '6em'
            }}
          >
            <Box
              style={{
                ...(pathname === '/dashboard' || hideSideNav === 'true'
                  ? {}
                  : {
                      width: 'min(100%, 1230px)',
                      paddingInline: '1rem'
                    }),
                margin: `${
                  hideSideNav === 'true'
                    ? '0px'
                    : pathname === '/dashboard'
                    ? '0px 0em'
                    : '0px auto'
                }`,
                boxSizing: 'border-box'
              }}
            >
              <Box
                style={{
                  width: open && '80%'
                }}
              >
                <Box
                  style={{
                    width: open && pathname !== '/dashboard' && '97%'
                  }}
                >
                  {children}
                </Box>
              </Box>
            </Box>

            <MainDrawer
              open={open}
              classes={classes}
              handleDrawerClose={handleDrawerClose}
              expanded={expanded}
              handleChange={handleChange}
              data={data}
            />
          </Box>
        </Body>
      </Box>
    </AppLogout>
  );
}

export default Layout;

/**
 *     </Wrapper> 
        {hideQuickStart === 'false' && data && data?.show === true && (
          <Box className={classes.quickstartContainer}>
            <Button
              variant='contained'
              disableElevation
              className={classes.quickStart}
              startIcon={<EmojiObjectsIcon />}
              onClick={handleDrawerOpen}
            >
              Quickstart
            </Button>
          </Box>
        )}
        </Wrapper>
 */
